<template>
    <div class="form-group breadcrumb-container">
        <div class="breadcrumb-inner">
            <app-breadcrumb class="breadcrumb p-0" :items="breadcrumbItems"></app-breadcrumb>
        </div>
    </div>
</template>

<script>
import { BBreadcrumb } from 'bootstrap-vue'
import { mapGetters } from "vuex"

export default {
    props: ["id", "routesName"],
    name: "NewBreadcrumb",
    data() {
        return {
            breadcrumbItems: [],
            menuDetailsCorrectIds: [8, 9, 10, 11],
            menuDetailsCorrectIds2: [10, 11],
            fiaIntelligenceTypeIds: [12],
        }
    },
    components: {
        appBreadcrumb: BBreadcrumb,
    },
    methods: {
        isInFiaIntelligenceTree(contentId) {
            let id = contentId;
            while (id) {
                const c = this.getContentById(id);
                if (!c) return false;
                if (this.fiaIntelligenceTypeIds.includes(c.contentTypeId)) return true;
                id = c.parentId;
            }
            return false;
        },

        isInfographicContent(content) {
            if (!content || !content.tags) return false;
            try {
                const infographicTagId = this.$store.state.tagIds.infographic;
                return JSON.parse(content.tags).some(t => t.tagId === infographicTagId);
            } catch (e) {
                return false;
            }
        },

        // Resolve a breadcrumb link for a node inside the FIA Intelligence tree the
        // same way FiaIntelligenceCard does, so clicking a crumb lands on the exact
        // page that node opens elsewhere (infographic, internal route, external link
        // or a FIA Intelligence section) instead of always forcing fiaIntelligenceDetails.
        resolveFiaTreeLink(content) {
            if (this.isInfographicContent(content)) {
                return { to: { name: 'news-content', params: { id: content.id } } };
            }
            if (content.url && content.url.startsWith('http')) {
                return { href: content.url, target: '_blank' };
            }
            if (content.url) {
                return { to: { name: content.url } };
            }
            return { to: { name: 'fiaIntelligenceDetails', params: { id: content.id, slug: content.slug } } };
        },

        loadBreadcrumbs() {
            // this.selectedLanguage = this.getSelectedLanguage.code;
            let urlToCheck = '';

            if (Array.isArray(this.routesName) && this.routesName.length > 0) {
                urlToCheck = this.routesName;
            } else if (this.routesName) {
                urlToCheck = this.routesName;
            }

            let contentId = 0;
            if (this.id != null) {
                contentId = this.id;
            }
            else {
                // A route name (e.g. the infographics listing) can be shared by more
                // than one content node. Prefer the node that lives inside the FIA
                // Intelligence tree so the full path is built, instead of a stale
                // standalone node that just happens to reuse the same url.
                const routeName = this.$route.name;
                const matches = this.$store.state.contents.filter(c => c.url === routeName);
                const chosen = matches.find(c => this.isInFiaIntelligenceTree(c.id)) || matches[0];
                contentId = chosen.id;
            }

            let items = [];

            do {
                let content = this.getContentById(contentId);
                let parent = null;
                if (content.parentId) {
                    parent = this.getContentById(content.parentId);
                }
                let isMatchingRoute;
                let matchingRouteName;
                if (this.routesName) {
                    isMatchingRoute = Array.isArray(this.routesName)
                        ? this.routesName.includes(content.url)
                        : content.url === this.routesName;

                    matchingRouteName = Array.isArray(this.routesName)
                        ? this.routesName.find(name => name === content.url)
                        : this.routesName;
                }

                let item = { text: content.title };
                if (this.isInFiaIntelligenceTree(content.id)) {
                    const link = this.resolveFiaTreeLink(content);
                    if (link.href) {
                        item.href = link.href;
                        item.target = link.target;
                    } else {
                        item.to = link.to;
                    }
                } else {
                    let routeName;
                    if (isMatchingRoute) {
                        routeName = matchingRouteName;
                    } else if ((parent && this.menuDetailsCorrectIds2.includes(parent.contentTypeId)) ||
                        (this.menuDetailsCorrectIds.includes(content.contentTypeId) && !parent)) {
                        routeName = 'menuDetailsNew';
                    } else {
                        routeName = 'contentNew';
                    }
                    item.to = { name: routeName, params: { id: content.id, slug: content.slug } };
                }

                items.push(item);
                contentId = content.parentId;

            } while (contentId);

            items.push({ html: "<i class='fa fa-home mr-1'></i> " + this.$t("homePage"), to: "/" });

            items[0].to = null;
            items[0].href = null;
            items[0].active = true;
            items = items.reverse();
            this.breadcrumbItems = items;
        }
    },
    computed: {
        ...mapGetters(["getContentById", "getContentByUrl", "getSelectedLanguage"])
    },
    created() {
        this.loadBreadcrumbs();
    },
    watch: {
        '$route.params.id'() {
            this.loadBreadcrumbs();
        }
    }
}
</script>

<style scoped>
.breadcrumb-container {
    padding: 10px 7%;
    max-width: 100%;
    margin-bottom: 0px;
}

.breadcrumb-inner {
    max-width: 1440px;
    margin: 0 auto;
}

.breadcrumb {
    background-color: var(--light-color);
    /* letter-spacing: -.5px; */
}

.breadcrumb a {
    color: var(--main-color);
    font-weight: bold;
    /* font-size: 15x; */
    font-size: clamp(1.15rem, 1.2vw, 1.1875rem);
}

.breadcrumb span{
    font-size: clamp(1.15rem, 1.2vw, 1.1875rem);
}

.breadcrumb a:hover {
    color: var(--main-color);
}

ol {
    margin-bottom: 0;
}
</style>